
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];angular
  .module('fca-used')
  .config(routesConfig)
  .run(scrollTopOnRouteChangeService);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(false).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('root', {
      url: '/',
      component: 'root',
      redirectTo: 'root.search',
      resolve: {
        translationsReady: translationsReady,
        clearEloquaVehicleData: clearEloquaVehicleData
      }
    })
    .state('root.search', {
      url: 'search',
      component: 'home',
      resolve: {
        clearEloquaVehicleData: clearEloquaVehicleData,
        clearLastQuery: clearLastQuery
      }
    })
    .state('root.results', {
      url: 'results',
      component: 'results',
      params: {
        query: null,
        trackLoad: true
      },
      resolve: {
        data: fetchResults,
        dealers: fetchDealers,
        clearEloquaVehicleData: clearEloquaVehicleData
      }
    })
    .state('root.details', {
      url: ':brand/:sincom/:siteCode/:vehicleCode',
      component: 'vehicleDetails',
      resolve: {
        data: fetchDetails,
        dealer: fetchDealer,
        phone: fetchMynumber,
        installments: fetchVehicleInstallments,
        setEloquaVehicleData: setEloquaVehicleData
      }
    });

  translationsReady.$inject = ['$translate'];

  function translationsReady($translate) {
    return $translate.onReady();
  }

  fetchResults.$inject = ['$q', '$state', '$transition$', 'uvl'];

  function fetchResults($q, $state, $transition$, uvl) {
    var query;
    try {
      query = $transition$.params().query || uvl.getLastQuery();
      if (query.location.geometry) {
        uvl.saveLastQuery(query);
      }
    } catch (err) {
      $state.go('root.search');
      return $q.reject('Missing search query');
    }
    return uvl.getVehiclesCount(query)
      .then(function () {
        return uvl.getVehicles(query);
      })
      .catch(function (error) {
        $state.go('root.search');
        return $q.reject('Error performing search query', {
          query: query,
          error: error
        });
      });
  }

  fetchDetails.$inject = ['$q', '$state', '$transition$', 'uvl'];

  function fetchDetails($q, $state, $transition$, uvl) {
    var vehicleCode = $transition$.params().vehicleCode;
    return uvl.getVehicleDetails(vehicleCode)
      .catch(function (error) {
        $state.go('root.results');
        return $q.reject('Error getting vehicle details', {
          vehicleCode: vehicleCode,
          error: error
        });
      });
  }

  fetchDealer.$inject = ['uvl', '$transition$'];

  function fetchDealer(uvl, $transition$) {
    var params = $transition$.params();
    return uvl.getDealer(params.brand, params.sincom, params.siteCode);
  }

  fetchMynumber.$inject = ['CONFIG', '$http', '$q', '$transition$'];
  function fetchMynumber(CONFIG, $http, $q, $transition$) {
    if (CONFIG.mynumber && CONFIG.mynumber.enabled) {
      var params = $transition$.params();
      return $http.post(CONFIG.mynumber.endpoint, {
        masterKey: CONFIG.mynumber.masterKey,
        sincom: params.sincom,
        siteCode: params.siteCode
      }).then(function (response) {
        var phone = {};
        phone.number = response.data.KcomNumber;
        if (CONFIG.mynumber.removePrefix) {
          phone.parsed = response.data.KcomNumber.replace(CONFIG.mynumber.removePrefix, '');
        }
        return phone;
      }).catch(function () {
        return false;
      });
    }
    return false;
  }

  fetchVehicleInstallments.$inject = ['$q', 'InstallmentsCalculator', 'data', 'CONFIG'];
  function fetchVehicleInstallments($q, InstallmentsCalculator, data, CONFIG) {
    if (CONFIG.installmentsCalculator && CONFIG.installmentsCalculator.enabled) {
      InstallmentsCalculator.init();
      return InstallmentsCalculator.getMonthlyRate(data)
        .then(function (response) {
          return response[InstallmentsCalculator.getMVS(data)];
        })
        .catch(function () {
          return $q.resolve(null);
        });
    }
    return $q.resolve(null);
  }

  fetchDealers.$inject = ['$window', '$q', '$state', '$transition$', 'uvl'];

  function fetchDealers($window, $q, $state, $transition$, uvl) {
    var query = $transition$.params().query || uvl.getLastQuery();
    if (!query) {
      $state.go('root.search');
      return $q.reject('Missing search query');
    }
    return uvl.getDealerList(query)
      .then(function (dealers) {
        var dealerObject = {};
        angular.forEach(dealers, function (dealer) {
          var brand = $window.parseInt(dealer.BRAND);
          dealerObject[dealer.SINCOM] = dealerObject[dealer.SINCOM] || {};
          dealerObject[dealer.SINCOM][brand] = dealerObject[dealer.SINCOM][brand] || [];
          dealerObject[dealer.SINCOM][brand].push(dealer);
        });
        return dealerObject;
      });
  }
}

scrollTopOnRouteChangeService.$inject = ['$window', '$transitions', '$log'];

function scrollTopOnRouteChangeService($window, $transitions, $log) {
  $transitions.onFinish({}, function () {
    try {
      $window.scroll({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    } catch (error) {
      $log.warn('Error in window.scroll function ' + error);
    }
  });
}

clearEloquaVehicleData.$inject = ['$window'];
function clearEloquaVehicleData($window) {
  delete $window.vehicleData;
}

setEloquaVehicleData.$inject = ['$window', 'data'];
function setEloquaVehicleData($window, data) {
  $window.vehicleData = data;
}

clearLastQuery.$inject = ['ResultHelper'];
function clearLastQuery(ResultHelper) {
  ResultHelper.reset();
}
